// extracted by mini-css-extract-plugin
export default {"iconButton":"styles_iconButton__VNYrb"};